import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addDept } from "@/api/admin/dept";
export default {
  props: {
    addData: {
      type: Object,
      required: true
    }
  },
  components: {},
  data: function data() {
    return {
      subDisabled: false,
      ruleForm: {},
      orgLevel: [{
        value: "1",
        label: "校级"
      }, {
        value: "2",
        label: "院系"
      }, {
        value: "3",
        label: "专业"
      }, {
        value: "4",
        label: "班级"
      }],
      teachUnit: [{
        value: "1",
        label: "是"
      }, {
        value: "0",
        label: "否"
      }],
      formValidate: {
        parenNode: "",
        nodeNum: "",
        name: "",
        detId: "",
        teachUnit: 1,
        orgLevel: 1,
        sort: 1,
        joinHie: 1,
        deptCode: ""
      },
      // 表单数据绑定
      ruleValidate: {
        name: [{
          required: true,
          message: "部门名称不能为空",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        deptCode: [{
          required: true,
          message: "部门编码不能为空",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }]
      } // 表单验证

    };
  },
  computed: {},
  methods: {
    showAddData: function showAddData() {
      this.formValidate.parenNode = this.addData.data.name;
      this.formValidate.depName = "";
      this.formValidate.parenNodeId = this.addData.data.id;
      this.formValidate.sort = 1;
      this.formValidate.teachUnit = 1;
      this.formValidate.orgLevel = 1;
      this.formValidate.joinHie = 1;
      this.formValidate.teachUnit = this.teachUnit[0].value;
      this.formValidate.orgLevel = this.orgLevel[0].value; // console.log(this.formValidate)
    },
    closeModal: function closeModal() {
      this.$emit("closeAdd", {
        state: false
      });
      this.addData.state = false;
      this.resetForm("ruleForm");
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // 新增
          // let subForm = {
          //     "name": this.formValidate.name,
          //     "sort": this.formValidate.sort,
          //     "deptCode": this.formValidate.deptCode,
          //     "parentId": this.formValidate.parenNodeId,
          //     "organType": this.formValidate.teachUnit,
          //     "joinHie": this.formValidate.joinHie,
          //     "organLevel": this.formValidate.orgLevel
          // };
          var subForm = {
            name: _this.formValidate.name,
            parentId: _this.formValidate.parenNodeId,
            sort: _this.formValidate.sort,
            deptCode: _this.formValidate.deptCode
          };
          _this.subDisabled = true;
          addDept(subForm).then(function (res) {
            _this.subDisabled = false;

            if (res.data.code == 0) {
              _this.formValidate = {
                parenNode: "",
                nodeNum: "",
                name: "",
                detId: "",
                teachUnit: 1,
                orgLevel: 1,
                sort: 1,
                joinHie: 1
              }; // 表单数据绑定

              _this.closeModal(); // 重新获取组织部门树


              _this.$store.dispatch("getDeptTree").then(function (data) {
                _this.$store.commit("SET_CHOOSE_DEPT", data.data.data);
              });

              _this.$store.dispatch("getStudentTree").then(function () {});
            } else {
              _this.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      var _this2 = this;

      this.$refs[formName].resetFields();
      setTimeout(function () {
        _this2.formValidate.parenNode = _this2.addData.data.name;
        _this2.formValidate.depName = "";
        _this2.formValidate.parenNodeId = _this2.addData.data.id;
        _this2.formValidate.sort = 1;
        _this2.formValidate.teachUnit = 1;
        _this2.formValidate.orgLevel = 1;
        _this2.formValidate.joinHie = 1;
        _this2.formValidate.teachUnit = _this2.teachUnit[0].value;
        _this2.formValidate.orgLevel = _this2.orgLevel[0].value;
      }, 200);
    }
  }
};